<div class="multi-select" (mouseleave)="showDropDown && shareCheckedlist()"  (click)="focusSel()">
    <button class="drop-toggle btn flat width-min" (click)="showDropDown=!showDropDown" [ngClass]="{'active': showDropDown}">
        <span *ngIf="!util.isNullOrBlank(selectedIt)">{{selectedIt.FormName}}({{selectedIt.PaperSize == '1' ? 'A4' : 'A3'}})</span>
        <i class="fa fa-caret-down arr-pading mar-left" aria-hidden="true"></i>
    </button>
    <div class="drop-show" [ngClass]="{'scroll-box': items.length >=10}" *ngIf="showDropDown">
        <div [ngClass]="{'it-disable': it.disable}" *ngFor="let it of items; index as i">
            <label (click)="checkItem(i)" [ngClass]="{'active': it.active}">
                {{it.FormName}}({{it.PaperSize == '1' ? 'A4' : 'A3'}})
            </label>
        </div>
    </div>
</div>
